import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";
import {Card} from "../../models/card";
import {Service} from "../../models/service";

@Component({
    selector: 'customer-already-exists-dialog',
    templateUrl: './customerAlreadyExistsDialog.component.html',
    styleUrls: ['./customerAlreadyExistsDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CustomerAlreadyExistsDialogComponent {
    action: string;
    customer: User;
    dialogTitle: string;
    dialogRef: any;
    card: Card;
    form: FormGroup;
    reason: string;

    constructor(
        public matDialogRef: MatDialogRef<CustomerAlreadyExistsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.translationLoader.loadTranslations(polish);
        this.reason = _data.reason;
    }


}
